import React, { useMemo } from 'react';

import CardChoice from 'features/CardChoice';
import CardSelector from 'features/CardSelector';
import ConsumerSearch from 'features/ConsumerSearch';
import CreditApplication from 'features/CreditApplication';
import ProductChoice from 'features/ProductChoice';
import MagicLinkVerification from 'features/magicLink/MagicLinkVerification';
import { RouteComponentProps } from 'react-router';

import useStartPageName from './useStartPageName';
import { useTrackApplicationStart } from 'hooks/useAnalytics';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import useLoadInitialTwoWayData from 'hooks/useLoadInitialTwoWayData';

/**
 * Entry point for the the Phone Lookup and Token Lookup workflows
 */
const Home: React.FC<RouteComponentProps> = props => {
  useLoadInitialTwoWayData();
  const { steps } = useWorkflow();

  const startPageName = useStartPageName();
  useTrackApplicationStart(startPageName);

  const Component = useMemo(() => {
    switch (steps[0]) {
      case Step.CARD_CHOICE:
        return CardChoice;
      case Step.CONSUMER_SEARCH:
        return ConsumerSearch;
      case Step.APPLICATION:
        return CreditApplication;
      case Step.PRODUCT_CHOICE:
        return ProductChoice;
      case Step.CARD_SELECTOR:
        return CardSelector;
      case Step.MAGIC_LINK_VERIFICATION:
        return MagicLinkVerification;

      default:
        // Uuuhh... not supposed to happen
        throw new Error(`Unexpected start route ${steps[0]}`);
    }
  }, [steps]);

  return <Component {...props} />;
};

export default Home;
